export default {
  title: 'Impressum',
  subtitle: 'Personalize os detalhes apresentados no Impressum da sua loja sem alterar o seu perfil empresarial.',
  defaultsNotice:
    'Todos os campos são opcionais. Deixe um campo vazio para continuar a usar o valor do seu perfil empresarial — o valor predefinido atual é mostrado a cinzento como pré-visualização. Preencher um campo substitui apenas o Impressum; o seu perfil empresarial não é alterado.',
  fields: {
    legal_name: {
      label: 'Nome da empresa / razão social',
      placeholder: 'ex.: Musterbetrieb GmbH',
    },
    owner_first_name: {
      label: 'Nome próprio do proprietário',
      placeholder: 'ex.: Alex',
    },
    owner_last_name: {
      label: 'Apelido do proprietário',
      placeholder: 'ex.: Müller',
    },
    owner_email: {
      label: 'E-mail',
      placeholder: 'ex.: info@example.com',
      invalid: 'Introduza um endereço de e-mail válido',
    },
    owner_phone_number: {
      label: 'Telefone',
      placeholder: 'ex.: +49 30 1234567',
    },
    tax_id: {
      label: 'NIF',
      placeholder: 'ex.: DE123456789',
    },
    address: {
      label: 'Morada',
      placeholder: 'Rua, código postal, localidade',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    saved: 'Impressum guardado',
    failed: 'Falha ao guardar o Impressum',
  },
};
